import { render, staticRenderFns } from "./editVanityName.vue?vue&type=template&id=a67b79ae&scoped=true&"
import script from "./editVanityName.vue?vue&type=script&lang=js&"
export * from "./editVanityName.vue?vue&type=script&lang=js&"
import style0 from "./editVanityName.vue?vue&type=style&index=0&id=a67b79ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b79ae",
  null
  
)

export default component.exports